// extracted by mini-css-extract-plugin
export default {"rightSection":"RightSection_rightSection__qW85B"};